




















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import vSelect from "vue-select";
import FolderTree from "@/components/common/folders/FolderTree.vue";
// service methods
import { getAllBackgrounds } from "@/services/backgrounds/backgroundService";
// types
import { Folder, FolderEntites } from "@/services/folders/types";
import { channelsModalFields } from "@/components/channels/fields/channelsModalFields";
import { Background } from "@/services/backgrounds/types";

@Component({
    components: {
        vSelect,
        "folder-tree": FolderTree
    }
})
export default class SelectBackgroundModal extends Vue {
    @Prop() id!: string;
    // local state
    backgrounds = [] as Array<Background>;
    selectedBackgrounds = [] as Array<Background>
    fields = channelsModalFields;
    isBusy = false;

    // folders
    folderEntity = FolderEntites.Backgrounds;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;

    // filter
    filterWidth = "" as string;
    filterHeight = "" as string;

    // filter options
    searchText = "" as string;

    open() {
        this.fetchData();
        this.$bvModal.show(this.id);
    }

    select(items: Background[]) {
        this.selectedBackgrounds = items;
    }

    save() {
        const background = this.backgrounds.find(x => x.id === this.selectedBackgrounds[0].id);
        this.$bvModal.hide(this.id);
        this.$emit("select", {
            id: this.selectedBackgrounds[0].id,
            name: background && background.name
        });
    }

    fetchData() {
        this.loadBackgrounds();
    }

    setSelectedFolder(folder: Folder) {
        this.selectedFolderNode = folder;
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
        }
    }

    loadBackgrounds() {
        this.isBusy = true;
        this.backgrounds = [] as Array<Background>;
        getAllBackgrounds().then(response => {
            this.backgrounds = response;
            this.isBusy = false;
        });
    }

    clearFilter() {
        this.filterWidth = "";
        this.filterHeight = "";
        this.loadBackgrounds();
    }

    resetState() {
        this.searchText = "";
        this.filterWidth = "";
        this.filterHeight = "";
    }

    // computed and watchers
    get model(): Array<Background> {
        if (this.filterActive) {
            return this.backgrounds.filter(
                x => (this.searchText === "" ? true : x.name.toLowerCase().includes(this.searchText.toLowerCase())) &&
                    (this.filterWidth === "" ? true : x.width === +this.filterWidth) &&
                    (this.filterHeight === "" ? true : x.height === +this.filterHeight)
            );
        } else {
            return this.backgrounds.filter(
                x => this.selectedFolderNode.id ? x.folderId === this.selectedFolderNode.id : true
            );
        }
    }

    get filterActive(): boolean {
        return (
            this.searchText !== "" ||
            this.filterWidth !== "" ||
            this.filterHeight !== "");
    }

    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        this.showFolderTree = !value;
    }
}
